import React from "react";
import T from "prop-types";
import { formValueSelector } from "redux-form";
import { connect } from "react-redux";
import { translateProps } from "MODULES/shared/decorators";
import { INVENTORIES } from "MODULES/inventories/constants";
import { dollars } from "LIB/formatters/currency";
import { alphaMonthYear } from "LIB/formatters/date";

export function Inventory({
  inventories,
  inventoryId,
  onSelect,
  disabled,
  showTable
}) {
  return (
    showTable && (
      <table className="table table-striped table-hover table-numbered">
        <thead>
          <tr>
            <th />
            <th />
            <th>Serial Number</th>
            <th>CD</th>
            <th>QTY</th>
            <th>Tag Date</th>
            <th>SRP CD</th>
            <th className="text-right">SRP</th>
            <th className="text-right">Exch SRP</th>
            <th className="text-right">Cost EA.</th>
          </tr>
        </thead>
        <tbody>
          {inventories.map((lineItem, i) => (
            <tr key={lineItem.id}>
              <td>{i + 1}</td>
              <td className="text-center">
                <input
                  type="radio"
                  name="read_only_inv"
                  className="radio-inline"
                  checked={lineItem.id === inventoryId}
                  onChange={() => onSelect(lineItem)}
                  disabled={disabled}
                />
              </td>
              <td>{lineItem.serial_number}</td>
              <td>
                {lineItem.condition &&
                  INVENTORIES.condition[lineItem.condition].abbrev}
              </td>
              <td>{lineItem.quantity}</td>
              <td>{alphaMonthYear(lineItem.tag_date)}</td>
              <td>
                {lineItem.srp_condition &&
                  INVENTORIES.condition[lineItem.srp_condition].abbrev}
              </td>
              <td className="text-right">
                {lineItem.suggested_retail &&
                  dollars(lineItem.suggested_retail)}
              </td>
              <td className="text-right">
                {lineItem.exchange_srp && dollars(lineItem.exchange_srp)}
              </td>
              <td className="text-right">
                {lineItem.cost_per_unit && dollars(lineItem.cost_per_unit)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  );
}

Inventory.propTypes = {
  inventories: T.arrayOf(
    T.shape({
      id: T.number.isRequired,
      serial_number: T.string.isRequired,
      condition: T.string.isRequired,
      tag_date: T.string.isRequired,
      srp_condition: T.string.isRequired,
      suggested_retail: T.string.isRequired,
      exchange_srp: T.string,
      cost_per_unit: T.string.isRequired
    })
  ).isRequired,
  inventoryId: T.number,
  onSelect: T.func.isRequired,
  disabled: T.bool,
  showTable: T.bool
};

const selector = formValueSelector("salesOrderLineItem");

const withInventoryId = connect(state => ({
  inventoryId: selector(state, "inventory_id")
}));

const withProps = translateProps(props => ({
  onSelect: inventory => {
    const { id, condition, dim_weight } = inventory;
    props.inventory_id.input.onChange(id);
    props.condition.input.onChange(condition);
    props.dim_weight.input.onChange(dim_weight);
    props.onSelect(inventory);
  }
}));

export default withInventoryId(withProps(Inventory));



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/Form/PartDetails/Inventory.jsx